import organization from '@/api/organizations';
import respondent from '@/api/respondents';

import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';

import Home from '@/views/Home/Index';

import Evaluation from '@/views/Evaluation/Index';
import EvaluationStart from '@/components/Evaluation/Start';
import EvaluationFinish from '@/components/Evaluation/Finish';
import EvaluationTerms from '@/components/Evaluation/Terms';
import EvaluationTutorial from '@/components/Evaluation/Tutorial';
import EvaluationSections from '@/components/Evaluation/Sections';
import EvaluationUserDetails from '@/components/Evaluation/UserDetails';
import EvaluationPurpose from '@/components/Evaluation/Purpose/Index';
import EvaluationAdaptability from '@/components/Evaluation/Dynamism/Index';
import EvaluationEcosystem from '@/components/Evaluation/Network/Index';
import EvaluationEmpowerment from '@/components/Evaluation/Empowerment/Index';
import EvaluationLeadership from '@/components/Evaluation/Leadership/Index';
import EvaluationResults from '@/components/Evaluation/Results';

import Demo from '@/views/Demo/Index';
import DemoSections from '@/components/Demo/Sections';
import DemoPurpose from '@/components/Demo/Purpose';
import DemoAdaptability from '@/components/Demo/Adaptability';
import DemoEcosystem from '@/components/Demo/Ecosystem';
import DemoEmpowerment from '@/components/Demo/Empowerment';
import DemoLeadership from '@/components/Demo/Leadership';
import DemoFinish from '@/components/Demo/Finish';
import DemoResults from '@/components/Demo/Results';


import Definition from '@/views/Definition/Index';
import PurposeDefinition from '@/components/Definition/Purpose';
import EcosystemDefinition from '@/components/Definition/Ecosystem';
import AdaptabilityDefinition from '@/components/Definition/Adaptability';
import EmpowermentDefinition from '@/components/Definition/Empowerment';
import LeadershipDefinition from '@/components/Definition/Leadership';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: 'organomyx',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      props: true,
    },
    {
      path: '/demo',
      name: 'demo',
      component: Demo,
      children: [
        {
          path: 'sections',
          name: 'demoSections',
          component: DemoSections,
          props: true,
        },
        {
          path: 'purpose',
          name: 'demoPurpose',
          component: DemoPurpose,
        },
        {
          path: 'adaptability',
          name: 'demoAdaptability',
          component: DemoAdaptability,
        },
        {
          path: 'ecosystem',
          name: 'demoEcosystem',
          component: DemoEcosystem,
        },
        {
          path: 'empowerment',
          name: 'demoEmpowerment',
          component: DemoEmpowerment,
        },
        {
          path: 'leadership',
          name: 'demoLeadership',
          component: DemoLeadership,
        },
        {
          path: 'finish',
          name: 'demoFinish',
          component: DemoFinish,
          meta: { demoFinished: true },
        },
        {
          path: 'results',
          name: 'demoResults',
          component: DemoResults,
          // meta: { demoFinished: true },
        },
      ],
    },
    {
      path: '/definition',
      name: 'definition',
      component: Definition,
      children: [
        {
          path: 'purpose',
          name: 'purpose-definition',
          component: PurposeDefinition,
        },
        {
          path: 'adaptability',
          name: 'adaptability-definition',
          component: AdaptabilityDefinition,
        },
        {
          path: 'ecosystem',
          name: 'ecosystem-definition',
          component: EcosystemDefinition,
        },
        {
          path: 'empowerment',
          name: 'empowerment-definition',
          component: EmpowermentDefinition,
        },
        {
          path: 'leadership',
          name: 'leadership-definition',
          component: LeadershipDefinition,
        },
      ],
    },
    {
      path: '/assessment/:id',
      name: 'evaluation',
      component: Evaluation,
      meta: { validId: true },
      children: [
        {
          path: 'start',
          name: 'start',
          component: EvaluationStart,
        },
        {
          path: 'terms',
          name: 'terms',
          component: EvaluationTerms,
        },
        {
          path: 'tutorial',
          name: 'tutorial',
          component: EvaluationTutorial,
        },
        {
          path: 'user-details',
          name: 'user-details',
          component: EvaluationUserDetails,
        },
        {
          path: 'sections',
          name: 'sections',
          component: EvaluationSections,
          props: true,
          meta: { userToken: true },
        },
        {
          path: 'purpose',
          name: 'Purpose',
          component: EvaluationPurpose,
          meta: { userToken: true },
          props: true,
        },
        {
          path: 'adaptability',
          name: 'Adaptability',
          component: EvaluationAdaptability,
          meta: { userToken: true },
          props: true,
        },
        {
          path: 'ecosystem',
          name: 'Ecosystems',
          component: EvaluationEcosystem,
          meta: { userToken: true },
          props: true,
        },
        {
          path: 'empowerment',
          name: 'Real Empowerment',
          component: EvaluationEmpowerment,
          meta: { userToken: true },
          props: true,
        },
        {
          path: 'leadership',
          name: 'Leadership',
          component: EvaluationLeadership,
          meta: { userToken: true },
          props: true,
        },
        {
          path: 'finish',
          name: 'finish',
          component: EvaluationFinish,
          meta: { userToken: true },
        },
        {
          path: 'results',
          name: 'results',
          component: EvaluationResults,
        },
      ],
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  const user = respondent.getRespondent();

  if (to.matched.some(record => record.meta.validId)) {
    organization.validate({ evaluation_code: to.params.id })
      .then(() => {
        if (to.matched.some(record => record.meta.userToken)) {
          if (user.auth_token) {
            next();
          } else {
            next({
              name: 'home',
            });
          }
        }
        next();
      }).catch(() => {
        next({
          name: 'home',
        });
      });
  }
  if (to.matched.some(record => record.meta.demoFinished)) {
    if (store.state.demoCountFinished === 5) {
      next();
    } else {
      next({
        name: 'home',
      });
    }
  }
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js